<template>
  <div class="title title-zoom" ref="titleZoom">{{ text }}</div>
</template>

<script>
export default {
  name: 'Title',
  props: ['text'],
  data() {
    return {}
  },
  mounted() {
    this.textFontSize(this.text)
  },
  methods: {
    textFontSize(text) {
      this.$nextTick(() => {
        // console.log(`${text}: ${text.length}`)
        // console.log(this.$refs.titleZoom)
        // fontSize 24px, 一个字的宽度为 15.4px
        let fontSize = 24
        let width = this.$refs.titleZoom.offsetWidth
        let length = text.length
        let fontWidth = width / length
        if (fontWidth < 15.5) {
          fontSize = fontWidth * 1.4
        }
        this.$refs.titleZoom.style.fontSize = `${fontSize}px`
      })
    },
  },
}
</script>

<style scoped lang="sass"></style>
